import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return (
      data
        // TODO: open this model with app-admin-xid role instead or allow app=admin to do app-admin-xid
        .filter(item => item.organization)
        .map(item => {
          return [
            {
              id: item.organization._id,
              parent_company_id: item.organization._id,
              division_id: null,
              xid: item.xid,
              text: `${item.organization.name} • ${item.xid}`,
            },
            ...item.organization.sys_organizations.map(div => ({
              id: div._id,
              parent_company_id: item.organization._id,
              division_id: div._id,
              xid: div.xid,
              text: `${item.organization.name} • Division: ${div.name} • ${item.xid}`,
            })),
          ]
        })
        .flat()
    )
  }, [data])
}
